import { BackgroundBlur, VirtualBackground } from '@livekit/track-processors';
import { VideoFilterParamsType, VideoFilterType } from './types';

export const getVideoFilter = (
  videoFilter: VideoFilterType,
  filterParams: VideoFilterParamsType,
) => {
  const { blurRadius, blurDelegate, virtualBackground } = filterParams;

  return videoFilter === 'blur'
    ? BackgroundBlur(blurRadius, { delegate: blurDelegate })
    : VirtualBackground(virtualBackground);
};
